import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, brl } from "@/lib/api";
import Header from "@/components/Header";
import { Heart, Gavel, MapPin } from "lucide-react";
import { toast } from "sonner";

export default function Favorites() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const load = () => api.get("/favorites").then((r) => setItems(r.data.favorites));
  useEffect(() => { load(); }, []);

  const remove = async (id, e) => {
    e.stopPropagation();
    await api.delete(`/favorites/${id}`);
    toast.success("Removido dos favoritos");
    load();
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex items-center gap-3">
          <Heart className="w-6 h-6 text-red-400 fill-red-400" />
          <h1 className="font-display text-3xl font-bold text-white">Meus Favoritos</h1>
        </div>
        <p className="text-slate-400 text-sm mt-1">Lotes salvos para acompanhamento até o fechamento da praça.</p>

        {items.length === 0 ? (
          <div className="mt-10 p-8 rounded-xl border border-dashed border-slate-800 text-center text-slate-400">
            Você ainda não favoritou nenhum lote. Clique no coração em qualquer resultado de pesquisa.
          </div>
        ) : (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((v) => (
              <div key={v.id} role="button" tabIndex={0} onClick={() => navigate(`/vehicle/${v.id}`)} onKeyDown={(e) => { if (e.key === "Enter") navigate(`/vehicle/${v.id}`); }} className="cursor-pointer text-left bg-slate-900/70 border border-slate-800 rounded-xl overflow-hidden card-hover relative" data-testid={`fav-card-${v.id}`}>
                <div className="aspect-video bg-slate-800 relative">
                  <img src={v.image} alt={v.model} className="w-full h-full object-cover" />
                  <div className="absolute top-2 left-2 deal-score">{v.analysis.score}/100</div>
                  {v.payment_25_30 && <div className="absolute top-2 right-2 badge-parcel"><Gavel className="w-3 h-3" />25% + 30x</div>}
                  <button type="button" onClick={(e) => remove(v.id, e)} className="absolute bottom-2 right-2 w-8 h-8 rounded-full bg-black/60 border border-red-500/40 flex items-center justify-center hover:bg-red-500/20" data-testid={`unfav-btn-${v.id}`}>
                    <Heart className="w-4 h-4 text-red-400 fill-red-400" />
                  </button>
                </div>
                <div className="p-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <div className="text-xs font-mono text-slate-500 flex items-center gap-1"><MapPin className="w-3 h-3" />{v.uf}</div>
                      <div className="font-semibold text-white mt-0.5">{v.brand} {v.model}</div>
                      <div className="text-xs text-slate-400">{v.year}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-[10px] uppercase text-emerald-400">{v.analysis.rating}</div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-between items-baseline">
                    <span className="font-mono text-emerald-400 font-bold">{brl(v.min_bid)}</span>
                    <span className="font-mono text-xs text-slate-500 line-through">{brl(v.fipe_value)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
